import { render, staticRenderFns } from "./PointsTabBar.vue?vue&type=template&id=8bc0f11a&scoped=true"
import script from "./PointsTabBar.vue?vue&type=script&lang=js"
export * from "./PointsTabBar.vue?vue&type=script&lang=js"
import style0 from "./PointsTabBar.vue?vue&type=style&index=0&id=8bc0f11a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc0f11a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bc0f11a')) {
      api.createRecord('8bc0f11a', component.options)
    } else {
      api.reload('8bc0f11a', component.options)
    }
    module.hot.accept("./PointsTabBar.vue?vue&type=template&id=8bc0f11a&scoped=true", function () {
      api.rerender('8bc0f11a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/PointsTabBar.vue"
export default component.exports